<script setup lang="ts">
import type { CmsElementBigTextBox } from "~/composables/useCustom";

const props = defineProps<{
  content: CmsElementBigTextBox;
}>();

const { heading, paragraph } = props.content?.config

</script>
<template>
  <section class="section section-main section-about section-about--alt section--solid" :style="props.style" :class="props.class">
    <div class="container">
      <header class="section__head">
        <h2>{{ heading.value }}</h2>
      </header><!-- /.section__head -->

      <div class="section__body">
        <div class="section__content section__content--alt" style="min-height: 250px;" v-html="paragraph.value">

        </div><!-- /.section__content -->
      </div><!-- /.section__body -->
    </div><!-- /.container -->
  </section>
</template>